import styled from 'styled-components';

import { BaseArrowDown } from '../../svg/ArrowDown';
import { breakpoints } from '../../constants';
import { convertHexToRGBA } from '../../utils';

interface IProps {
    className?: string;
    backgroundColor: string;
    onClick?(): void;
}

const BaseNavArrow = ({ className, onClick }: IProps) => (
    <div className={className} role="button" onClick={onClick}>
        <BaseArrowDown />
    </div>
);

interface IStyledProps {
    direction: 'left' | 'right';
}

export const NavArrow = styled(BaseNavArrow)<IStyledProps>`
    width: 30px;
    position: absolute;
    top: 0;
    left: ${({ direction }) => (direction === 'left' ? 0 : 'auto')};
    right: ${({ direction }) => (direction === 'right' ? 0 : 'auto')};
    height: 100%;
    background: linear-gradient(
        to ${({ direction }) => direction},
        ${({ backgroundColor }) => convertHexToRGBA(backgroundColor, 0)},
        ${({ backgroundColor }) => backgroundColor} 20%
    );

    svg {
        transform: translateX(-50%)
            rotate(
                ${({ direction }) =>
                    direction === 'left' ? '90deg' : '-90deg'}
            );
        width: 15px;
        height: 15px;
        position: absolute;
        left: 50%;
        top: 35%;
    }

    @media (${breakpoints.mediumMin}) {
        display: none;

        svg {
            top: 55%;
        }
    }
`;
